/* eslint-disable no-loss-of-precision */
/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Radio,
  Button,
  Tooltip,
  Spin,
  message,
  Dragger,
  Modal,
  Upload,
} from "antd";
import { checkNumbervalue } from "../../../utils";
import { HeaderWithBottomLine } from "../../Master/CpOnbordingSteps/HeaderWithBottomLine";
import { contentDiscriptionData } from "../../../components/contentDiscriptionData";
import crosImgForChildBagagge from "../../../assests/crosImgForChildBagagge.svg";
import pluse from "../../../assests/images/childpackagePluseIcon.svg";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  getServiceAbilityCheck,
  getServiceAbilityCheckReset,
  getChildPacketIds,
} from "../../../actionsMethods/cashBookingMethods";
import { getCalculaterRateChart } from "../../../actionsMethods/cashBookingMethods";
import { APIs, getToken } from "../../../utils/worker";
import axios from "axios";
import { camelCase } from "../../../utils";
import {
  getBarcodeId,
  postShipment,
  clearBarcodeId,
  clearPostShipment,
  updateShipment,
  clearUpdateShipment,
  clearChildPacketIds,
} from "../../../actionsMethods/cashBookingMethods";
import Alert from "../Alerts";
import AccountAddress from "../../AccountBookingPage/AccountAddress";
import uploadLogo from "../../../assests/images/bx_upload.svg";
import { StarOutlined } from "@ant-design/icons";

const BasicDetails = () => {
  const { Option } = Select;
  const lgm = 6;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [fileList, setfileList] = useState([]);

  const userToken = JSON.parse(window?.localStorage?.getItem("userinfo"));
  const user_premiseId = JSON.parse(window?.localStorage?.getItem("userId"));
  const pickUpPinCode = user_premiseId?.premises?.pincode;
  const pickUpPinStatus = user_premiseId?.premises?.stateCode;

  const [nonDox, setNonDox] = useState(false);
  const { cityData, provinceData } = contentDiscriptionData();
  const [cities, setCities] = useState(cityData[provinceData[0]]);
  const [childPacket, setChildPacket] = useState(false);
  const [validorNot, setValidorNot] = useState({});
  const [clientName, setClientName] = useState([]);
  const [department, setDepartment] = useState([]);
  const [filesData, setFileData] = useState([]);
  const [bookingDetails, setBookingDetails] = useState({});
  console.log({ bookingDetails });
  const [destinationDetails, setdestinationDetails] = useState();
  const [alertData, setAlertData] = useState(false);
  const [searchData, setSearchData] = useState();
  const [pinLoading, setPinLoading] = useState(false);
  const [destinationPremiseId, setDestinationPremiseId] = useState();
  const [receiverAreaId, setReceiverAreaId] = useState("");

  let initalChildData = [
    {
      id: Math.random().toString(36).slice(2),
      length: 0,
      width: 0,
      height: 0,
      total: 0,
    },
  ];
  const [childInput, setchildInput] = useState(initalChildData);
  const [totalValue, setTotalValue] = useState({});
  let mergeArr = [];

  const [childPayload, setChildPayload] = useState();

  const getUpdateShipmentResponse = useSelector(
    (state) => state.appReducer.getUpdateShipmentReducer
  );
  const {
    result: updateShip,
    error: updateShipErr,
    fetching: updateFeatch,
  } = getUpdateShipmentResponse;

  const serviceabilityCheckResponse = useSelector(
    (state) => state?.appReducer?.getServiceAbilityCheckReducer,
    shallowEqual
  );

  const {
    fetching: loading,
    result: tatData,
    error: err,
  } = useSelector(
    (state) => state?.appReducer?.getCalculaterTatChartReducer,
    shallowEqual
  );

  const { fetching, result, error } = useSelector(
    (state) => state.appReducer.getBarcodeIdReducer,
    shallowEqual
  );

  const postShipmentResponse = useSelector(
    (state) => state?.appReducer?.getPostShipmentReducer,
    shallowEqual
  );

  const {
    fetching: loader2,
    result: postShipmentResult,
    error: postError,
  } = postShipmentResponse;

  const chidlPacketIdsResponse = useSelector(
    (state) => state.appReducer.getChildPacketIdsReducer
  );

  const {
    error: childIdsError,
    result: childIdsResult,
    fetching: loadering3,
  } = chidlPacketIdsResponse;

  const clearFunction = () => {
    form.resetFields();
    setBookingDetails({});
    setNonDox(false);
    setChildPacket(false);
    setchildInput(initalChildData);
    setfileList([]);
    setTotalValue({});

    dispatch(clearChildPacketIds());
    dispatch(getServiceAbilityCheckReset());
    dispatch(clearUpdateShipment());
    dispatch(clearBarcodeId());
    dispatch(clearPostShipment());
    setValidorNot({});
    getClient();
    form.setFieldValue("child_Selected", false);
    form.setFieldValue("cod", "no");
    form.setFieldValue("fov", "no");
  };

  useEffect(() => {
    if (updateShip !== null) {
      setAlertData({
        visible: true,
        message: "Booking successfully completed",
        data: result,
      });
      // clearFunction();
    }
  }, [updateFeatch]);

  useEffect(() => {
    if (
      childIdsError ||
      postError ||
      error ||
      serviceabilityCheckResponse.error
    ) {
      message.error(
        childIdsError?.message ||
          postError?.message ||
          error?.message ||
          updateShipErr?.message ||
          serviceabilityCheckResponse.error.message
      );
    }
  }, [
    childIdsError,
    postError,
    error,
    updateShipErr,
    serviceabilityCheckResponse.error,
  ]);

  useEffect(() => {
    clearFunction();
  }, []);

  useEffect(() => {
    if (childPacket === false) {
      if (tatData !== null) {
        if (loader2 == false && postShipmentResult !== null) {
          dispatch(updateShipment(newdata, result?.data?.awbNumber));
        }
      }
    }
  }, [loader2, postShipmentResult, tatData]);

  useEffect(() => {
    if (childPacket) {
      if (
        postShipmentResult !== null &&
        tatData !== null &&
        loader2 === false &&
        childIdsResult !== null
      ) {
        let arrData = fun();
        let childFeildsDetails =
          arrData &&
          arrData?.map((val) => {
            return {
              weight: val?.totalweight,
              height: val?.height,
              length: val?.length,
              width: val?.width,
            };
          });

        childIdsResult?.map((e, i) => {
          mergeArr?.push({
            ...e,
            ...childFeildsDetails[i],
          });
        });
        postChildPackets(childFeildsDetails);
      }
    } else if (childIdsError !== null) {
      message.error(childIdsError.message);
    }
  }, [loader2, loadering3]);

  useEffect(() => {
    form.setFieldsValue({
      noOfChildPacket: childInput?.length,
    });
  }, [childInput]);

  useEffect(() => {
    if (serviceabilityCheckResponse.fetching == false) {
      pinCodeVlidater();
    }
  }, [serviceabilityCheckResponse.fetching]);

  useEffect(() => {
    if (loading == false && err) {
      pinCodeVlidater();
    }
  }, [loading]);

  const serviceType = () => {
    let serviceType = "1";
    let data = form.getFieldValue("service");
    let selectedMode = data;
    if (selectedMode === "2") {
      serviceType = "Fast Track";
    }
    if (selectedMode === "3") {
      serviceType = "Value Plus";
    }
    if (selectedMode === "1") {
      serviceType = "Standard";
    }
    return serviceType;
  };

  let expDate = serviceType() + form.getFieldValue("travelBy") + "Date";

  var newObj = Object.keys(tatData !== null ? tatData?.data : "")
    .filter((key) => key?.toLocaleLowerCase() == expDate?.toLocaleLowerCase())
    .reduce(
      (newObj, currKey) => ((newObj[currKey] = tatData?.data[currKey]), newObj),
      {}
    );

  let expDate1 = newObj ? Object.values(newObj).toString().split(" ")[0] : "";

  let destinationHubId = destinationDetails?.find(
    (e) => e.premiseId == destinationPremiseId
  );

  let newdata = {
    sourcePincode: +user_premiseId?.premises?.pincode,
    clientId: bookingDetails?.clientId,
    cod: bookingDetails?.values?.cod == "yes" ? true : false,
    fov: bookingDetails?.values?.fov == "yes" ? true : false,
    addressDetails: {
      ...bookingDetails.addressDetails,
      customerId: 1960581322055966062,
      receiverName: bookingDetails?.values?.name,
      receiverAddressLine1: bookingDetails?.values?.addressLine1,
      receiverAddressLine2: bookingDetails?.values?.addressLine2,
      receiverCity: bookingDetails?.values?.city,
      receiverPincode: +bookingDetails?.values?.pincode,
      receiverState: bookingDetails?.values?.state,
      receiverAreaId: receiverAreaId,
      receiverAreaName: bookingDetails?.values?.area,
      receiverMobileNumber: +bookingDetails?.values?.mobileNumber,
      receiverEmail: bookingDetails?.values?.receiverEmail || "",
    },
    shipmentDetails: {
      type: bookingDetails?.values?.docType,
      description: bookingDetails?.values?.description,
      content: bookingDetails?.values?.content,
      value: +bookingDetails?.values?.valueInrNonDox || 0,
      weight: +bookingDetails?.values?.weight || null,
      width: +bookingDetails?.values?.width || null,
      height: +bookingDetails?.values?.height || null,
      length: +bookingDetails?.values?.length || null,
      ewayBillNumber: bookingDetails?.values?.ewayBillNo,
      destinationPincode: +bookingDetails?.values?.deliveryPincode,
      service: 1,
      destinationCpId: destinationPremiseId,
      destinationHubId: destinationHubId?.parentId,
      premiseId: user_premiseId?.userInfo?.premiseId,
      userID: user_premiseId?.userInfo?.userId,
      bookingType: "Account",
      volumetricWeight: +bookingDetails?.values?.totalVolWeight,
      clientName: bookingDetails?.values?.client,
      expectedDeliveryDate: expDate1,
    },
    serviceDetails: {
      service: serviceType(),
      travelBy: bookingDetails?.values?.travelBy,
    },

    file: filesData?.length
      ? filesData?.map((val) => ({
          fileName: val?.filePath,
          fileId: val?.id,
        }))
      : [],
    bookingStatus: "UPDATED",
    local: false,
  };

  let fun = () => {
    let arr = [];
    Object.keys(bookingDetails.values)?.forEach(function (key) {
      const sp = key.split("length");
      if (sp[1] && sp[1] !== "") {
        const wid = `width${sp[1]}`;
        const height = `height${sp[1]}`;
        const len = `length${sp[1]}`;
        const total = `total${sp[1]}`;

        const oj = {
          length: bookingDetails.values[len],
          width: bookingDetails.values[wid],
          height: bookingDetails.values[height],
          totalweight: bookingDetails.values[total],
        };
        arr.push(oj);
      }
    });
    return arr;
  };

  useEffect(() => {
    if (childPacket) {
      if (loading == false && tatData !== null) {
        dispatch(updateShipment(newdata, result?.data?.awbNumber));
      }
    }
  }, [loading, tatData]);

  // const [first, setfirst] = useState(second)

  const postChildPackets = async (values) => {
    let destinationPincode = form.getFieldValue("deliveryPincode");
    let data = mergeArr?.map((val, index) => {
      return {
        childAwbNumber: val?.awbNumber,
        description: "Demo Description1",
        value: 0.0,
        service: form.getFieldValue("service"),
        weight: +val.weight,
        height: +val.height,
        length: +val.length,
        width: +val.width,
        ewayBillNumber: null,
        destinationPincode,
        destinationCpId: destinationPremiseId,
        destinationHubId: destinationHubId?.parentId,
        travelBy: bookingDetails?.values?.travelBy,
      };
    });
    try {
      let res = await axios.post(
        `${APIs.baseURL}/shipment-service/v1/shipment/${result?.data?.awbNumber}/child`,
        data,
        {
          headers: {
            Authorization: "Bearer " + userToken.accessToken,
          },
        }
      );
      if (res.data) {
        message.success("Child shipment successfully added");
        let childNums = res.data?.childShipments?.map(
          (val) => val.childAwbNumber
        );
        // dispatch(updateShipment(newdata, result?.data?.awbNumber));
      }
    } catch (error) {
      message.error(error?.response?.data?.message);
    }
  };

  const getClient = () => {
    const headers = {
      Authorization: "Bearer " + userToken.accessToken,
      cpId: user_premiseId?.userInfo?.premiseId,
    };

    axios
      .get(`${APIs.baseURL}/client-onboard/v1/cp/clients`, {
        headers: headers,
      })
      .then((response) => {
        if (response.status == 200) {
          let temp = response?.data?.filter(
            (o) => o.status === "Approved" && o.enable === true
          );
          setClientName(temp);
        }
      })
      .catch((error) => {
        message.error(error?.response?.data?.message);
      });
  };

  const getDepartMent = async (clientDetails) => {
    const headers = {
      Authorization: "Bearer " + userToken.accessToken,
      cpId: user_premiseId?.userInfo?.premiseId,
    };

    let response = await axios.get(
      `${APIs.baseURL}/client-onboard/v1/organizations/${clientDetails?.key}`,
      {
        headers: headers,
      }
    );

    if (response.status == 200) {
      let res = response?.data?.clientOrganizationDetails?.departmentName;
      let details = response?.data?.clientOnboard;
      setDepartment(res);
      let addressDetails = {
        senderName: details?.clientName,
        // receiverState: data?.State,
        // receiverPincode: deliveryPincode,
        senderAddressLine1: details?.addressline1,
        senderAddressLine2: details?.addressline2 ? details?.addressline2 : "",
        senderPincode: details?.pincode,
        senderState: details?.state,
        senderMobileNumber: details?.primaryNum,
        senderEmail: details?.emailId,
        senderCity: details?.city,
        senderGst: details?.gstin,
      };

      setBookingDetails((prevState) => {
        return {
          ...prevState,
          addressDetails: addressDetails,
          clientId: response?.data?.clientOrganizationDetails?.clientId,
        };
      });
      // upDateAllData({ addressDetails}, { clientDetails });
    } else {
      message.error(response?.data?.message);
    }
    // })
    // .catch((error) => {
    //   message.error(error?.response?.data?.message);
    //   // setLoading(false);
    // });
  };

  const lg = 5;
  const sm = 5;

  const pinCodeVlidater = () => {
    if (
      serviceabilityCheckResponse.fetching == false &&
      serviceabilityCheckResponse?.error
    ) {
      setValidorNot({
        validateStatus: "error",
        errorMsg: serviceabilityCheckResponse?.error?.message,
      });
    } else if (
      serviceabilityCheckResponse?.fetching == false &&
      serviceabilityCheckResponse?.error
    ) {
      setValidorNot({
        validateStatus: "error",
        errorMsg: serviceabilityCheckResponse?.result?.message,
      });
    } else if (loading == false && err) {
      setValidorNot({
        validateStatus: "error",
        errorMsg: err?.message,
      });
      setSearchData(serviceabilityCheckResponse?.result?.areas);
    } else if (
      serviceabilityCheckResponse?.fetching == false &&
      serviceabilityCheckResponse?.result?.areas?.length === 0
    ) {
      setValidorNot({
        validateStatus: "error",
        errorMsg: "Area names not found for this pincode",
      });
      setSearchData(serviceabilityCheckResponse?.result?.areas);
    } else {
      setValidorNot({
        validateStatus: "success",
        errorMsg: null,
      });
      setSearchData(serviceabilityCheckResponse?.result?.areas);
    }
  };

  const onChangeDoxType = (e) => {
    if (e == "Non-dox") {
      setNonDox(true);
      form.setFieldsValue({
        content: null,
        description: null,
        weight: null,
        length: null,
        width: null,
        height: null,
        totalVolWeight: null,
        child_Selected: false,
        valueInr: null,
      });
      setChildPacket(false);
    } else {
      setNonDox(false);
      setChildPacket(false);
      form.setFieldsValue({
        content: "Document",
        weight: null,
        valueInr: null,
        description: null,
      });
    }
  };

  const handleProvinceChange = (value) => {
    setCities(cityData[value]);
    // setSecondCity(cityData[value][0]);
    form.setFieldsValue({
      description: null,
    });
  };

  const valumCalculation = (e) => {
    let length = form.getFieldValue("length");
    let widht = form.getFieldValue("width");
    let height = form.getFieldValue("height");
    let volum = ((+length * +widht * +height) / 5000).toFixed(2);
    form.setFieldsValue({
      totalVolWeight: volum,
    });
  };

  let addFormFields = () => {
    setchildInput([
      ...childInput,
      {
        id: Math.random().toString(36).slice(2),
        length: 0,
        width: 0,
        height: 0,
        total: 0,
      },
    ]);
  };

  let removeFormFields = (id) => {
    form.setFieldValue("length" + id, null);
    form.setFieldValue("width" + id, null);
    form.setFieldValue("height" + id, null);

    let newFormValues = [...childInput];

    newFormValues.splice(
      newFormValues.findIndex(function (i) {
        return i.id === id;
      }),
      1
    );

    // newFormValues.splice(i, 1);
    setchildInput(newFormValues);
    calcuLateTotal("e", id);
  };

  const calCulateChildPacket = () => {
    if (+form.getFieldValue("noOfChildPacket") > childInput.length) {
      const data = +form.getFieldValue("noOfChildPacket") - childInput.length;
      let temp = [...childInput];
      for (let i = 0; i < data; i++) {
        temp.push({
          id: Math.random().toString(36).slice(2),
          length: 0,
          width: 0,
          height: 0,
          total: 0,
        });
      }
      setchildInput(temp);
    } else if (+form.getFieldValue("noOfChildPacket") < childInput.length) {
      const data = childInput.length - +form.getFieldValue("noOfChildPacket");

      let temp = [...childInput];
      temp.splice(childInput.length - data, data);
      setchildInput(temp);
      let chi = form.getFieldValue("noOfChildPacket");
      let hh = 0;
      let ww = 0;
      let ll = 0;
      let tot = 0;
      for (let i = 0; i < chi; i++) {
        let h = +form.getFieldValue("height" + childInput[i].id);
        let w = +form.getFieldValue("width" + childInput[i].id);
        let l = +form.getFieldValue("length" + childInput[i].id);
        hh = isNaN(h) ? 0 + hh : h + hh;
        ww = isNaN(w) ? 0 + ww : w + ww;
        ll = isNaN(l) ? 0 + ll : l + ll;

        let tot = hh + ww + ll / 5000;
      }
      let x = {
        totalWidth: ww,
        totalHeight: hh,
        totalLength: ll,
        totalOfTotal: tot,
      };
      setTotalValue({ ...x });
      // xyz(temp);
    }
  };

  const calcuLateTotal = (e, id) => {
    let h = +form.getFieldValue("height" + id);
    let w = +form.getFieldValue("width" + id);
    let l = +form.getFieldValue("length" + id);
    let height = isNaN(h) ? 0 : h;
    let width = isNaN(w) ? 0 : w;
    let length = isNaN(l) ? 0 : l;

    let total = (height * width * length) / 5000;

    form.setFieldsValue({
      [`total${id}`]: total.toFixed(2),
    });

    let formData = form.getFieldsValue();
    let totalWidth = 0;
    let totalHeight = 0;
    let totalLength = 0;
    let totalTotal = 0;
    for (let i = 0; i < childInput.length; i++) {
      let hh = +form.getFieldValue("height" + childInput[i].id);
      let ww = +form.getFieldValue("width" + childInput[i].id);
      let ll = +form.getFieldValue("length" + childInput[i].id);
      let tt = +form.getFieldValue("total" + childInput[i].id);

      totalHeight += isNaN(hh) ? 0 : hh;
      totalWidth += isNaN(ww) ? 0 : ww;
      totalLength += isNaN(ll) ? 0 : ll;
      totalTotal += isNaN(tt) ? 0 : tt;
    }

    setTotalValue({
      totalWidth: totalWidth,
      totalHeight: totalHeight,
      totalLength: totalLength,
      totalOfTotal: totalTotal,
    });
  };
  const pincodeHandle = async (values) => {
    // if (values > 5) {
    setPinLoading(true);

    try {
      let response = await fetch(
        `https://api.postalpincode.in/pincode/${+values}`
      );
      let res = await response.json();
      if (res?.length > 0) {
        {
          res?.map((data) => {
            data?.PostOffice?.map((data) => {
              form.setFieldsValue({
                city: data?.District,
                state: data?.State,
                areaName: data?.Name,
                pincode: +values,
              });
            });
          });
        }
        setPinLoading(false);
      }
    } catch (error) {
      setPinLoading(false);
    }
  };
  const myFUnction = (e) => {
    dispatch(getServiceAbilityCheck(e.target.value, userToken.accessToken));
    // dispatch(getPinCodeArea(e.target.value));
    pincodeHandle(e.target.value);
    // dispatch(
    //   getCalculaterRateChart({
    //     to: user_premiseId?.premises?.pincode,
    //     from: e.target.value,
    //     destinationPremiseId,
    //   })
    // );
  };

  const inputHandler = (e) => {
    dispatch(getServiceAbilityCheckReset());
    form.setFieldsValue({ area: null });
    if (e.target.value.length > 5) {
      myFUnction(e);
    }
  };

  let suffixStatus = serviceabilityCheckResponse?.result?.serviceability;
  const { Dragger } = Upload;

  const getDestinationId = async () => {
    let deliveryPincode = form.getFieldValue("deliveryPincode");

    try {
      let res = await axios.get(
        `${APIs.baseURL}/premise-service/v1/premise/pincode/${deliveryPincode}`,

        {
          headers: {
            Authorization: "Bearer " + userToken.accessToken,
          },
        }
      );
      if (res.data) {
        // setdestinationDetails({
        //   destinationCPId: res?.data[0]?.premiseId,
        //   destinationHubId: res?.data[0]?.parentId,
        // });
        setdestinationDetails(res?.data);
      }
    } catch (error) {
      message.error(error.message);
    }
  };

  const onFinish = (values) => {
    setBookingDetails({ ...bookingDetails, values });
    // getDestinationId(values);
    dispatch(
      getCalculaterRateChart({
        to: user_premiseId?.premises?.pincode,
        from: values?.deliveryPincode,
        destinationPremiseId,
      })
    );

    let data1 = {
      awbNumber: result?.data?.awbNumber,
      premiseId: user_premiseId?.userInfo?.premiseId,
      bookingType: "Account",
      userId: user_premiseId?.userInfo?.userId,
      destinationPincode: +values?.deliveryPincode,
    };
    dispatch(postShipment(data1, user_premiseId?.userInfo?.premiseId));

    childPacket
      ? dispatch(
          getChildPacketIds(
            6,
            childInput?.length,
            user_premiseId?.userInfo?.premiseId
          )
        )
      : "";
  };

  const handleOnChangeClient = (a, clientDetails) => {
    form.setFieldsValue({ department: null });
    getDepartMent(clientDetails);
  };

  const handleChange = (info) => {
    let allFiles = info?.fileList?.map((val) => val?.response?.data);
    // let v1 = allFiles?.map((val) => val?.displayName);

    if (info.file.status === "done") {
      message.success(info.file.response.message);
      setFileData(allFiles);
    }
    if (info.file.status === "removed") {
      setFileData(allFiles);

      localStorage.setItem("allFiles", JSON.stringify(allFiles));
    }
    if (info.file.status === "error") {
      message.error("File not Supported");
    }
    setfileList(info.fileList);
  };
  let authToken = getToken();

  const handleRemove = (file) => {
    const { confirm } = Modal;
    let config = {
      headers: {
        Authorization: authToken,
      },
    };
    return new Promise((resolve, reject) => {
      confirm({
        title: "Are you sure you want to Delete ?",
        onOk: async () => {
          resolve(true);
          try {
            let res = await axios.delete(
              `${APIs.baseURL}/file-service/v1/file/${file?.response?.data?.id}`,
              config
            );

            if (res) {
              message.success(res.data);
            }
          } catch (error) {
            // message.error(error.data + "world");
          }
        },
        onCancel: () => {
          reject(true);
        },
      });
    });
  };

  const beforeUpload = (file, onSuccess) => {
    const isJpgOrPng =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "application/pdf";
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (file) {
      let checkSameFile = fileList
        ?.map((val) => val?.name)
        .some((val) => val === file.name);

      if (file.name.includes("jfif")) {
        message.error("File not supported");
        return Upload.LIST_IGNORE;
      }
      if (checkSameFile) {
        message.error("Same file cannot be uploaded again");
        return Upload.LIST_IGNORE;
      }
      if (!isLt2M) {
        message.error("File size should be less than 2MB");
        return Upload.LIST_IGNORE;
      }
      if (!isJpgOrPng) {
        message.error("File not supported");
        return Upload.LIST_IGNORE;
      }
      return isJpgOrPng && isLt2M;
    } else {
      if (onSuccess) {
        message.success("File uploaded");
      }
      onSuccess("ok");
      return true;
    }
  };

  const props = {
    name: "files",
    multiple: true,
    listType: "picture",
    showUploadList: true,
    action: `${APIs.baseURL}/file-service/v1/file`,
    headers: { Authorization: ` ${authToken}` },

    className: "upload-list-inline",

    onChange(info) {
      if (info.file.status === "done") {
        // Handle response from API
      }
    },

    removeIcon: <StarOutlined />,
  };

  const onChange = (value) => {
    dispatch(clearBarcodeId());
    dispatch(
      getBarcodeId(value, user_premiseId?.userInfo?.premiseId, "ACCOUNT")
    );
  };

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");

  const handlePreview = async (file) => {
    if (file.response.data.displayName.split(".")[1] == "pdf") {
      window.open(file.response.data.filePath);
    } else {
      console.log(file);
      let imagePath = filesData.filter(
        ({ id }) => file?.response?.data?.id === id
      )[0].filePath;
      console.log(imagePath);
      setPreviewImage(imagePath);
      setPreviewOpen(true);
      setPreviewTitle(
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
      );
    }
  };
  const handleCancel = () => setPreviewOpen(false);

  let opt = [
    {
      value: "1",
      label: "Standard",
    },
    {
      value: "3",
      label: "Value plus",
    },

    {
      value: "2",
      label: "Fast track",
    },
  ];

  const getAreaPremiseId = async (values, areaId) => {
    let response = await axios.get(
      APIs.baseURL + `/premise-service/v1/premise/areas/premise-id/${areaId}`,
      {
        headers: {
          Authorization: "Bearer " + userToken.accessToken,
        },
      }
    );

    if (response.status) {
      setDestinationPremiseId(response.data);
    } else {
      // sentPhoneOtp(values);
      message.error("somthing went wrong");
    }
  };

  const handleAreaChange = (e, v) => {
    getAreaPremiseId(e, v?.key);
    setReceiverAreaId(v?.key);
    getDestinationId();
  };

  return (
    <Spin
      spinning={serviceabilityCheckResponse.fetching || fetching || pinLoading}
    >
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewImage}
        />
      </Modal>
      {alertData && (
        <Alert
          alertData={alertData}
          allData={bookingDetails}
          clearFunction={clearFunction}
        />
      )}

      <div style={{ padding: "40px 40px 14px 40px", background: "#FFFFFF" }}>
        <Form
          // {...layout}
          form={form}
          name="accountBasicDetails"
          onFinish={onFinish}
          layout="vertical"
          scrollToFirstError={{
            behavior: "smooth",
            block: "center",
            inline: "center",
          }}
          initialValues={{
            docType: "Dox",
            content: "Document",
          }}
          className="global-form step-2-form"
        >
          <HeaderWithBottomLine text={"Basic Details"} icon={false} />
          <Row className="global-form-row" gutter={16}>
            <Col lg={lgm}>
              <Form.Item
                name="client"
                label="Client"
                rules={[
                  {
                    required: true,
                    message: "Please select client",
                    validateTrigger: "onSubmit",
                  },
                ]}
              >
                <Select
                  placeholder="Select client"
                  onSelect={(value, event) =>
                    handleOnChangeClient(value, event)
                  }
                >
                  {clientName?.map(({ clientId, clientName }) => (
                    <Option key={clientId} value={clientName}>
                      {camelCase(clientName)}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col lg={lgm} sm={6}>
              <Form.Item
                name="department"
                label="Department"
                rules={[
                  {
                    required: true,
                    message: "Please enter value",
                    validateTrigger: "onSubmit",
                  },
                ]}
              >
                <Select placeholder="Select department">
                  {department?.map((e) => (
                    <Option key={e} value={e}>
                      {e}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col lg={lgm} sm={6}>
              <Form.Item
                name="pickupPincode"
                className="accpickupPincodeParent"
                label="Pickup PIN code"
              >
                <Input
                  value={pickUpPinCode}
                  minLength={6}
                  readOnly={true}
                  className="accpickupPincode"
                  suffix={<div className="green">{pickUpPinStatus}</div>}
                  // className="pincodeInputaccount"
                  // className="pincodeInput"
                />
                {""}
              </Form.Item>
            </Col>

            <Col lg={lgm} sm={6}>
              <Form.Item
                name="deliveryPincode"
                validateStatus={validorNot?.validateStatus}
                help={validorNot?.errorMsg}
                className="accpickupPincodeParent"
                label="Delivery PIN code"
                rules={[
                  {
                    required: true,
                    message: "Please enter value",
                    validateTrigger: "onSubmit",
                  },
                  () => ({
                    validator(rule, value = "") {
                      if (value.length > 0 && value.length < 6) {
                        return Promise.reject("Pincode should be 6 digits");
                      } else {
                        return Promise.resolve();
                      }
                    },

                    validateTrigger: "onSubmit",
                  }),
                ]}
                onKeyPress={(event) => {
                  if (checkNumbervalue(event)) {
                    event.preventDefault();
                  }
                }}
              >
                <Input
                  // className="pincodeInput"
                  onChange={inputHandler}
                  className="accpickupPincode"
                  placeholder="Enter delivery PIN code"
                  maxLength={6}
                  suffix={
                    <div
                      className={
                        suffixStatus?.serviceability === "Regular"
                          ? "green"
                          : suffixStatus?.serviceability === " Premium"
                          ? "orange"
                          : "red"
                      }
                    >
                      {suffixStatus?.stateCode}
                    </div>
                  }
                />
              </Form.Item>
            </Col>
            <Col lg={lgm} sm={6}>
              <Form.Item
                name="area"
                rules={[
                  {
                    required: true,
                    message: "Please select  value",
                  },
                ]}
                label="Area"
              >
                <Select
                  showSearch
                  placeholder="Search area"
                  // onSelect={handleAreaChange}
                  onSelect={(value, event) => handleAreaChange(value, event)}
                >
                  {searchData?.map((option) => (
                    <Option
                      key={option?.areaId}
                      value={camelCase(option?.areaName)}
                    >
                      {option?.id}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col lg={lgm} sm={6}>
              <Form.Item
                name="docType"
                label="Type"
                rules={[
                  {
                    required: true,
                    message: "Please enter value",
                  },
                ]}
              >
                <Select
                  placeholder="Select DOX type"
                  optionFilterProp="children"
                  onChange={(e) => onChangeDoxType(e)}
                  options={[
                    {
                      value: "Dox",
                      label: "Dox",
                    },
                    {
                      value: "Non-dox",
                      label: "Non-Dox",
                    },
                  ]}
                ></Select>
              </Form.Item>
            </Col>
            <Col lg={lgm} sm={6}>
              <Form.Item name="content" label="Content">
                <Select
                  placeholder="Select a content"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={handleProvinceChange}
                  options={
                    nonDox
                      ? provinceData.map((province) => ({
                          label: province,
                          value: province,
                        }))
                      : [
                          {
                            value: "Document",
                            label: "Document",
                          },
                        ]
                  }
                ></Select>
              </Form.Item>
            </Col>
            <Col lg={lgm} sm={6}>
              <Form.Item
                name="description"
                rules={[
                  {
                    required: true,
                    message: "Please select  value",
                  },
                ]}
                label="Descriptions"
              >
                <Select
                  placeholder="Select a description"
                  optionFilterProp="children"
                  options={
                    nonDox
                      ? cities?.map((city) => ({
                          label: city,
                          value: city,
                        }))
                      : [
                          {
                            value: "Form, Catalogue & Paper",
                            label: "Form, Catalogue & Paper",
                          },
                          {
                            value: "Passport",
                            label: "Passport",
                          },
                          {
                            value: "Tender Document",
                            label: "Tender Document",
                          },
                        ]
                  }
                ></Select>
              </Form.Item>
            </Col>
            {!nonDox ? (
              <>
                <Col lg={lgm} sm={6}>
                  <Form.Item
                    label={
                      <span className="calculater-container-pikpin">
                        {"Weight(Gms)"}
                      </span>
                    }
                    name="weight"
                    rules={[
                      {
                        required: true,
                        message: "Please enter value",
                      },

                      () => ({
                        validator(_, value) {
                          if (!value) {
                            return Promise.reject();
                          }
                          if (parseInt(value.substring(1, 0)) === 0) {
                            return Promise.reject("Value should not be 0");
                          }
                          if (value < 50) {
                            return Promise.reject(
                              "Weight should be more than 50Gm"
                            );
                          }

                          if (value > 900) {
                            return Promise.reject(
                              "Weight should be less than 900Gm"
                            );
                          }

                          return Promise.resolve();
                        },

                        validateTrigger: "onSubmit",
                      }),
                    ]}
                    onKeyPress={(event) => {
                      if (checkNumbervalue(event)) {
                        event.preventDefault();
                      }
                      var invalidChars = ["."];
                      if (invalidChars.includes(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  >
                    <Input
                      className="pincodeInput"
                      placeholder="Enter weight"
                      maxLength={3}
                      min={1}
                    />
                  </Form.Item>
                </Col>
                <Col lg={lgm} sm={6}>
                  <Form.Item
                    label="Service"
                    name="service"
                    rules={[
                      {
                        required: true,
                        message: "Please enter  value",
                      },
                      () => ({
                        validator(_, value) {
                          if (!value) {
                            return Promise.reject();
                          }

                          if (value < 1) {
                            return Promise.reject(
                              "Length should be more than 1Cm"
                            );
                          }

                          return Promise.resolve();
                        },
                      }),
                    ]}
                    onKeyPress={(event) => {
                      if (checkNumbervalue(event)) {
                        event.preventDefault();
                      }
                    }}
                  >
                    <Select
                      className="pincodeType-placecholder"
                      placeholder="Select service"
                      optionFilterProp="children"
                      onChange={onChange}
                    >
                      {user_premiseId?.premises?.city == "Rajkot"
                        ? opt?.map((item, i) => (
                            <Option key={item.value} value={item.value}>
                              {item.label}
                            </Option>
                          ))
                        : opt
                            .filter((e) => e.label !== "Value plus")

                            .map((item, i) => (
                              <Option key={item.value} value={item.value}>
                                {item.label}
                              </Option>
                            ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col lg={lgm} sm={6}>
                  <Form.Item
                    name="travelBy"
                    rules={[
                      {
                        required: true,
                        message: "Please select  value",
                      },
                    ]}
                    label="Travel by"
                  >
                    <Select
                      className="pincodeType-placecholder"
                      placeholder="Select  Travel by"
                      optionFilterProp="children"
                      options={[
                        {
                          value: "Surface",
                          label: "Surface",
                        },
                        {
                          value: "Air",
                          label: "Air",
                        },
                      ]}
                    ></Select>
                  </Form.Item>
                </Col>
              </>
            ) : (
              <>
                <Col lg={lgm} sm={6}>
                  <Form.Item
                    label={
                      <span className="calculater-container-pikpin">
                        {" "}
                        Weight(Kg)
                      </span>
                    }
                    name="weight"
                    rules={[
                      {
                        required: true,
                        maxLength: 3,
                        message: "Please enter value",
                      },
                      {
                        pattern: /^[0-9]{1,3}(\.[0-9]{1,2})?$/g,
                        message: "Invalid weight",
                      },
                      () => ({
                        validator(_, value) {
                          if (!value) {
                            return Promise.reject();
                          }
                          if (parseInt(value.substring(1, 0)) === 0) {
                            return Promise.reject("Value should not be 0");
                          }
                          return Promise.resolve();
                        },

                        validateTrigger: "onSubmit",
                      }),
                    ]}
                    onKeyPress={(event) => {
                      if (checkNumbervalue(event)) {
                        event.preventDefault();
                      }
                    }}
                  >
                    <Input
                      className="pincodeInput"
                      placeholder="Enter weight"
                      maxLength={6}
                      onChange={(e) => valumCalculation(e)}
                      min={1}
                    />
                  </Form.Item>
                </Col>
                <Col lg={lgm} sm={6}>
                  <Form.Item
                    label={
                      <span className="calculater-container-pikpin">
                        {" "}
                        Length(Cm)
                      </span>
                    }
                    name="length"
                    rules={[
                      {
                        required: true,
                        message: "Please enter  value",
                      },
                      () => ({
                        validator(_, value) {
                          if (!value) {
                            return Promise.reject();
                          }

                          if (value < 1) {
                            return Promise.reject(
                              "Length should be more than 1Cm"
                            );
                          }

                          return Promise.resolve();
                        },
                      }),
                    ]}
                    onKeyPress={(event) => {
                      if (checkNumbervalue(event)) {
                        event.preventDefault();
                      }
                    }}
                  >
                    <Input
                      placeholder="Enter length"
                      maxLength={3}
                      onChange={(e) => valumCalculation(e)}
                    />
                  </Form.Item>
                </Col>
                <Col lg={lgm} sm={6}>
                  <Form.Item
                    label=" Width(Cm)"
                    name="width"
                    rules={[
                      {
                        required: true,
                        message: "Please enter  value",
                      },
                      () => ({
                        validator(_, value) {
                          if (!value) {
                            return Promise.reject();
                          }

                          if (value < 1) {
                            return Promise.reject(
                              "Width should be more than 1Cm"
                            );
                          }

                          return Promise.resolve();
                        },
                      }),
                    ]}
                    onKeyPress={(event) => {
                      if (checkNumbervalue(event)) {
                        event.preventDefault();
                      }
                    }}
                  >
                    <Input
                      placeholder="Enter width"
                      maxLength={3}
                      onChange={(e) => valumCalculation(e)}
                      min={"0"}
                    />
                  </Form.Item>
                </Col>
                <Col lg={lgm} sm={6}>
                  <Form.Item
                    label={
                      <span className="calculater-container-pikpin">
                        {" "}
                        Height (Cm)
                      </span>
                    }
                    name="height"
                    rules={[
                      {
                        required: true,
                        message: "Please enter value",
                      },
                      () => ({
                        validator(_, value) {
                          if (!value) {
                            return Promise.reject();
                          }

                          if (value < 1) {
                            return Promise.reject(
                              "Height should be more than 1Cm"
                            );
                          }

                          return Promise.resolve();
                        },
                      }),
                    ]}
                    onKeyPress={(event) => {
                      if (checkNumbervalue(event)) {
                        event.preventDefault();
                      }
                    }}
                  >
                    <Input
                      className="pincodeInput"
                      placeholder="Enter height"
                      maxLength={3}
                      onChange={(e) => valumCalculation(e)}
                    />
                  </Form.Item>
                </Col>
                <Col lg={lgm} sm={6}>
                  <Form.Item label="  Vol Weight (Kg)" name="totalVolWeight">
                    <Input
                      className="pincodeInput"
                      readOnly={true}
                      type="number"
                    />
                  </Form.Item>
                </Col>
                <Col lg={lgm} sm={6}>
                  <Form.Item
                    label="Service"
                    name="service"
                    rules={[
                      {
                        required: true,
                        message: "Please enter  value",
                      },
                    ]}
                    onKeyPress={(event) => {
                      if (checkNumbervalue(event)) {
                        event.preventDefault();
                      }
                    }}
                  >
                    <Select
                      className="pincodeType-placecholder"
                      placeholder="Select a Service"
                      optionFilterProp="children"
                      onChange={onChange}
                    >
                      {user_premiseId?.userInfo?.premiseId == 43
                        ? opt?.map((item, i) => (
                            <Option key={item.value} value={item.value}>
                              {item.label}
                            </Option>
                          ))
                        : opt
                            .filter((e) => e.label !== "Value plus")

                            .map((item, i) => (
                              <Option key={item.value} value={item.value}>
                                {item.label}
                              </Option>
                            ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col lg={lgm} sm={6}>
                  <Form.Item
                    name="travelBy"
                    rules={[
                      {
                        required: true,
                        message: "Please select  value",
                      },
                    ]}
                    label="Travel by"
                  >
                    <Select
                      className="pincodeType-placecholder"
                      placeholder="Select a Travel"
                      optionFilterProp="children"
                      options={[
                        {
                          value: "Surface",
                          label: "Surface",
                        },
                        {
                          value: "Air",
                          label: "Air",
                        },
                      ]}
                    ></Select>
                  </Form.Item>
                </Col>
                <Col lg={lgm} sm={6}>
                  <Form.Item
                    name="valueInrNonDox"
                    label={
                      <span className="calculater-container-pikpin">
                        Value (INR)
                      </span>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please enter a value",
                        // validateTrigger: "onSubmit",
                      },
                      {
                        pattern: /^[0-9].*/g,
                        message: "Initial value should be numeric.",
                      },
                      // {
                      //   pattern: /^\d{1,6}(\.\d{0,2})?$/,
                      //   message: "Format should be 000.00",
                      // },
                      () => ({
                        validator(rule, value = "") {
                          if (parseInt(value.substring(1, 0)) === 0) {
                            return Promise.reject("Value should not be 0");
                          } else {
                            return Promise.resolve();
                          }
                        },
                        // validateTrigger: "onSubmit",
                      }),
                    ]}
                    onKeyPress={(event) => {
                      if (checkNumbervalue(event)) {
                        event.preventDefault();
                      }
                    }}
                  >
                    <Input placeholder="Enter value" maxLength={7} />
                  </Form.Item>
                </Col>

                <Col lg={lgm} sm={6}>
                  <Form.Item
                    name={"child_Selected"}
                    label="Child Packets"
                    rules={[
                      {
                        required: true,
                        message: "Please enter value",
                      },
                    ]}
                  >
                    <Radio.Group
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "20%",
                      }}
                      onChange={(e) => {
                        setchildInput(initalChildData),
                          setTotalValue({}),
                          setChildPacket(JSON.parse(e.target.value));
                      }}
                      rules={[
                        {
                          required: true,
                          message: "Please select value",
                        },
                      ]}
                    >
                      <Radio value={true}>Yes</Radio>
                      <Radio value={false}>No</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>

                {childPacket ? (
                  <>
                    {" "}
                    <Col lg={6} sm={6}>
                      <Form.Item
                        label="No of child packet"
                        name="noOfChildPacket"
                        rules={[
                          {
                            maxLength: 2,
                            message: null,
                          },
                          () => ({
                            validator(_, value) {
                              if (value == 0) {
                                return Promise.reject({
                                  message: "value should not be 0",
                                });
                              }
                              return Promise.resolve({});
                            },
                          }),
                        ]}
                        onKeyPress={(event) => {
                          if (checkNumbervalue(event)) {
                            event.preventDefault();
                          }
                        }}
                      >
                        <Input
                          className="pincodeInput"
                          placeholder="Enter no of packets"
                          maxLength={2}
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      lg={12}
                      sm={6}
                      style={{
                        display: "flex",
                        alignItem: "center",
                        marginTop: "23px",
                        paddingBottom: "10px",
                      }}
                    >
                      <Form.Item
                        name="chilPackegeButton"
                        className="chilPackegeButton"
                        style={{ paddingTop: "10px" }}
                      >
                        <Button
                          onClick={() => calCulateChildPacket()}
                          className="btn-style save-btn ml-1"
                        >
                          {"ADD VOLUMETRIC"}
                        </Button>
                      </Form.Item>
                    </Col>
                  </>
                ) : (
                  ""
                )}
              </>
            )}
            {!nonDox && (
              <Col lg={lgm} sm={6}>
                <Form.Item
                  name="valueInrNonDox"
                  label={
                    <span className="calculater-container-pikpin">
                      Value (INR)
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please enter a value",
                    },
                    {
                      pattern: /^[0-9].*/g,
                      message: "Initial value should be numeric.",
                    },
                    // {
                    //   pattern: /^\d{1,6}(\.\d{0,2})?$/,
                    //   message: "Format should be 000.00",
                    // },
                    () => ({
                      validator(rule, value = "") {
                        if (parseInt(value.substring(1, 0)) === 0) {
                          return Promise.reject("Value should not be 0");
                        } else {
                          return Promise.resolve();
                        }
                      },
                      // validateTrigger: "onSubmit",
                    }),
                  ]}
                  onKeyPress={(event) => {
                    if (checkNumbervalue(event)) {
                      event.preventDefault();
                    }
                  }}
                >
                  <Input placeholder="Enter value" maxLength={7} />
                </Form.Item>
              </Col>
            )}
          </Row>
          {childPacket ? (
            <>
              <HeaderWithBottomLine text={"Child packets"} />
              {childInput.map((element, index) => (
                <Row key={index}>
                  <Col lg={lg} sm={sm}>
                    <Form.Item
                      label={
                        <span className="childPacketLabel">
                          Length per packet (Cm)
                        </span>
                      }
                      name={"length" + element.id}
                      rules={[
                        {
                          required: true,
                          maxLength: 3,
                          message: "Please enter value",
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        className="pincodeInput"
                        placeholder="Enter length"
                        maxLength={3}
                        min={1}
                        onKeyPress={(e) => {
                          if (e.target.value.length >= 3) {
                            e.target.value = e.target.value.substring(
                              0,
                              e.target.value.length - 1
                            );
                          }
                          if (e.code === "Minus") {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) =>
                          calcuLateTotal(e.target.value, element.id)
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={lg} sm={sm} offset={1}>
                    <Form.Item
                      label={
                        <span className="childPacketLabel">
                          Width per packet(Cm)
                        </span>
                      }
                      name={"width" + element.id}
                      rules={[
                        {
                          required: true,
                          message: "Please enter  value",
                        },
                      ]}
                      onKeyPress={(event) => {
                        if (checkNumbervalue(event)) {
                          event.preventDefault();
                        }
                      }}
                    >
                      <Input
                        type="number"
                        className="pincodeInput"
                        placeholder="Enter width"
                        maxLength={3}
                        onChange={(e) =>
                          calcuLateTotal(e.target.value, element.id)
                        }
                        onKeyPress={(e) => {
                          if (e.target.value.length >= 3) {
                            e.target.value = e.target.value.substring(
                              0,
                              e.target.value.length - 1
                            );
                          }
                          if (e.code === "Minus") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={lg} sm={sm} offset={1}>
                    <Form.Item
                      label={
                        <span className="childPacketLabel">
                          Height per packet (Cm)
                        </span>
                      }
                      name={"height" + element.id}
                      rules={[
                        {
                          required: true,
                          message: "Please enter  value",
                        },
                      ]}
                      onKeyPress={(event) => {
                        if (checkNumbervalue(event)) {
                          event.preventDefault();
                        }
                      }}
                    >
                      <Input
                        type="number"
                        className="pincodeInput"
                        placeholder="Enter height"
                        maxLength={3}
                        min={"0"}
                        onChange={(e) =>
                          calcuLateTotal(e.target.value, element.id)
                        }
                        onKeyPress={(e) => {
                          if (e.target.value.length >= 3) {
                            e.target.value = e.target.value.substring(
                              0,
                              e.target.value.length - 1
                            );
                          }
                          if (e.code === "Minus") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={lg} sm={sm} offset={1}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Please enter  value",
                        },
                      ]}
                      label={
                        <span className="childPacketLabel">
                          Total Vol Weight (Kg)
                        </span>
                      }
                      // style={style}
                      name={"total" + element.id}
                      onKeyPress={(event) => {
                        if (checkNumbervalue(event)) {
                          event.preventDefault();
                        }
                      }}
                    >
                      <Input
                        type="number"
                        className="pincodeInput"
                        value={1}
                        maxLength={3}
                        readOnly={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={1} className="delete-child-input">
                    <div
                      style={{
                        height: "65px",
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Tooltip placement="right" title={"Delete"}>
                        <Button
                          type="text"
                          style={{ background: "none", width: "0" }}
                          disabled={childInput.length == 1 ? true : false}
                        >
                          <img
                            src={crosImgForChildBagagge}
                            className="delete-child-input-button"
                            onClick={() => {
                              removeFormFields(element.id);
                            }}
                          />
                        </Button>
                      </Tooltip>{" "}
                    </div>
                  </Col>
                  {/* )} */}
                </Row>
                // </div>
              ))}
              <Button
                style={{
                  background: "none",
                  border: " 1px solid #2E77D0",
                  color: "#2E77D0",
                  width: "auto",
                  margin: "10px 0",
                  borderRadius: "4px",
                }}
                className="child-baggage-modal-inputList-button-style"
                onClick={() => addFormFields()}
                type="dashed"
              >
                <div className="child-baggage-modal-inputList-button">
                  ADD CHILD PACKET
                  <img src={pluse} style={{ paddingLeft: "10px " }} />
                </div>
              </Button>

              <Row className="child-baggage-totalVolume">
                <Col lg={6} className="child-baggage-totalVolume-col1">
                  Length : {totalValue.totalLength || 0} Cm
                </Col>
                <Col lg={6} className="child-baggage-totalVolume-col1">
                  Width : {totalValue.totalWidth || 0} Cm
                </Col>
                <Col lg={6} className="child-baggage-totalVolume-col1">
                  Height : {totalValue.totalHeight || 0} Cm
                </Col>
                <Col lg={5} className="child-baggage-totalVolume-col1">
                  Total Volumetric : {totalValue.totalOfTotal?.toFixed(2) || 0}
                  Kg
                </Col>
                <Col lg={1}></Col>
              </Row>
            </>
          ) : (
            ""
          )}

          <AccountAddress
            form={form}
            bookingDetails={bookingDetails}
            key={bookingDetails?.addressDetails}
          />
          <HeaderWithBottomLine text={"Service Details"} icon={false} />
          <Row className="global-form-row">
            <Col lg={6} sm={sm}>
              <Form.Item name="cod" label="COD">
                <Radio.Group style={{ display: "flex", columnGap: "40px" }}>
                  <Radio value={"yes"}>Yes </Radio>
                  <Radio value={"no"}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col lg={6} sm={sm}>
              <Form.Item name="fov" label="FOV">
                <Radio.Group style={{ display: "flex", columnGap: "40px" }}>
                  <Radio value={"yes"}>Yes </Radio>
                  <Radio value={"no"}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <HeaderWithBottomLine text={"Upload Document"} icon={false} />
          <ul style={{ marginLeft: "-19px" }}>
            <li>
              Click the icon or drag and drop to upload supporting documents
            </li>
            <li>Supported file type: PDF, JPEG, PNG and Max 10MB file size</li>
          </ul>
          <Row className="upload_and_dragger">
            <Col>
              <div className="one-row">
                <Dragger
                  {...props}
                  className="dragger"
                  onChange={handleChange}
                  onRemove={handleRemove}
                  maxCount={10}
                  fileList={fileList}
                  beforeUpload={beforeUpload}
                  onPreview={handlePreview}
                  multiple={false}
                  headers={{
                    "SMCS-PREMISE-ID": user_premiseId?.userInfo?.premiseId,
                    awbNumber: result?.data?.awbNumber,
                    Authorization: authToken,
                  }}
                >
                  <Row>
                    <Col span={sm}>
                      <img src={uploadLogo} className="Upload_logo" />
                    </Col>
                    <Col span={1} className="vline"></Col>
                    <Col span={17}>
                      <p>Choose file</p>
                    </Col>
                  </Row>
                </Dragger>
              </div>
            </Col>
          </Row>

          <hr className="divider" style={{ marginTop: "20px" }} />

          <div className="d-flex flex-end mt-1">
            <Button
              htmlType="submit"
              className="btn-style save-btn ml-1"
              disabled={childIdsError !== null ? true : false}
            >
              SUBMIT
            </Button>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default BasicDetails;
